<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import KidInputName from './KidInputName.vue'
import KidSelectGrade from './KidSelectGrade.vue'
import KidDisciplineLinks from './KidDisciplineLinks.vue'

defineOptions({
  name: 'KidGeneralInfo',
})
</script>

<template>
  <div class="kid-info-group">
    <AppText name="body1-medium">
      General info
    </AppText>
    <div class="kid-info-group__list">
      <KidInputName />
      <KidSelectGrade />
      <KidDisciplineLinks />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KidInfoGroup.scss" />
